import type { FlowAction } from '../core/types/chat.types'

export const TOOLKIT_EXPORT_ACTION_VALUES = [
  'EXP_PDF_MSG',
  'EXP_WORD_MSG',
  'EXPORT_MSG_PPT',
] as const

export const MESSAGE_TOOLKIT_EXPORT_ACTIONS: ReadonlyArray<FlowAction> = [
  {
    actionValue: 'EXP_PDF_MSG',
    actionType: 'button',
    actionText: 'Export PDF',
  },
  {
    actionValue: 'EXP_WORD_MSG',
    actionType: 'button',
    actionText: 'Export Word',
  },
  {
    actionValue: 'EXPORT_MSG_PPT',
    actionType: 'button',
    actionText: 'Export PowerPoint',
  },
]

export const isToolkitExportActionValue = (actionValue?: string | null): boolean => {
  if (!actionValue) return false
  return TOOLKIT_EXPORT_ACTION_VALUES.includes(
    actionValue as (typeof TOOLKIT_EXPORT_ACTION_VALUES)[number],
  )
}

export const getToolkitExportLabel = (actionValue: string, fallbackText?: string): string => {
  if (actionValue === 'EXP_PDF_MSG') return 'Export PDF'
  if (actionValue === 'EXP_WORD_MSG') return 'Export Word'
  if (actionValue === 'EXPORT_MSG_PPT') return 'Export PowerPoint'
  return fallbackText || 'Export'
}
